import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Fuel, Gauge, Settings, MapPin, ArrowRight, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../Utils/formatters';
import './VehicleCard.css';

const VehicleCard = (car) => {
  const { id, title, brand, price, images, type, year, location, specs, category } = car;
  const [imageLoaded, setImageLoaded] = useState(false);

  const categoryLabels = {
    premium: 'Premium',
    business: 'Business',
    luxury: 'Luxury',
    economy: 'Ekonomik',
    electric: 'Elektrikli',
    suv: 'SUV',
  };

  const categoryColors = {
    premium: '#00c2ff',
    business: '#a78bfa',
    luxury: '#f59e0b',
    economy: '#10b981',
    electric: '#06b6d4',
    suv: '#f97316',
  };

  const catColor = categoryColors[category] || '#00c2ff';
  const isRental = type === 'Kiralık';
  const hasRentalPrices = car.price_daily || car.price_weekly || car.price_monthly;

  return (
    <motion.div 
      layout
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.23, 1, 0.32, 1] }}
      viewport={{ once: true }}
      className="vc-card"
    >
      {/* Image Area */}
      <div className="vc-image-wrapper">
        <Link to={`/detail/${type}/${id}`} className="vc-image-link">
          <img 
            src={images[0]} 
            alt={title} 
            className={`vc-image ${imageLoaded ? 'vc-image-loaded' : ''}`}
            onLoad={() => setImageLoaded(true)}
          />
          <div className="vc-image-overlay"></div>
        </Link>
        
        {/* Category Badge */}
        <div className="vc-category-badge" style={{ background: catColor }}>
          {category === 'electric' && <Zap size={12} />}
          {categoryLabels[category] || 'Standart'}
        </div>

        {/* Year Tag */}
        <div className="vc-year-tag">{year}</div>

        {/* Quick Specs on Image */}
        <div className="vc-quick-specs">
          <div className="vc-quick-spec">
            <Fuel size={14} />
            <span>{specs.fuelType}</span>
          </div>
          <div className="vc-quick-spec-divider"></div>
          <div className="vc-quick-spec">
            <Settings size={14} />
            <span>{specs.transmission}</span>
          </div>
          <div className="vc-quick-spec-divider"></div>
          <div className="vc-quick-spec">
            <Gauge size={14} />
            <span>{specs.enginePower || '120 HP'}</span>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="vc-content">
        <div className="vc-brand">{brand}</div>
        <h3 className="vc-title">{title}</h3>
        
        <div className="vc-meta-row">
          <div className="vc-location">
            <MapPin size={14} />
            <span>{location.city}</span>
          </div>

          {/* Price Display */}
          {isRental && hasRentalPrices ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
              {car.price_daily && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ fontSize: '0.58rem', fontWeight: 800, color: '#4ade80', textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8 }}>Günlük</span>
                  <span style={{ fontSize: '0.88rem', fontWeight: 900, color: '#4ade80' }}>{formatCurrency(car.price_daily)}</span>
                </div>
              )}
              {car.price_weekly && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ fontSize: '0.58rem', fontWeight: 800, color: '#fbbf24', textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8 }}>Haftalık</span>
                  <span style={{ fontSize: '0.88rem', fontWeight: 900, color: '#fbbf24' }}>{formatCurrency(car.price_weekly)}</span>
                </div>
              )}
              {car.price_monthly && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ fontSize: '0.58rem', fontWeight: 800, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8 }}>Aylık</span>
                  <span style={{ fontSize: '0.88rem', fontWeight: 900, color: '#a78bfa' }}>{formatCurrency(car.price_monthly)}</span>
                </div>
              )}
            </div>
          ) : (
            <div className="vc-price">{formatCurrency(price)}</div>
          )}
        </div>

        <div className="vc-footer">
          <Link to={`/detail/${type}/${id}`} className="vc-detail-link">
            <span>Detayları İncele</span>
            <ArrowRight size={16} />
          </Link>
          <Link to="/teklif-al" className="vc-cta-btn">
            Teklif Al
          </Link>
        </div>
      </div>

      {/* Hover Glow */}
      <div className="vc-glow" style={{ background: catColor }}></div>
    </motion.div>
  );
};

export default VehicleCard;
